import styled from '@emotion/styled';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const ArrowUp = (props) => {
  const { fill, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        d="M14.125 5.87744L5.875 14.1274"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33325 5.83545L14.1249 5.87628L14.1666 11.6688"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default ArrowUp;
